import CSVUtils from './CsvUtils'
import { saveAs } from 'file-saver'

const buildURI = (data, type) => {
  const blob = new window.Blob([data], { type })
  const dataURI = `data:${type};charset=utf-8${data}`

  const URL = window.URL || window.webkitURL

  return typeof URL.createObjectURL === 'undefined' ? dataURI : URL.createObjectURL(blob)
}

const buildCSVURI = (data, options) => buildURI(CSVUtils.unparse(data, options), 'text/csv')

const download = (fileURI, { filename }) => {
  saveAs(fileURI, filename)
}

export default {
  buildURI,
  buildCSVURI,
  download
}
